<li class="prom-dropdown__listitems {option.cssClass || ''}"
    class:prom-dropdown__listitems--divider={option.divider}
    class:prom-dropdown__listitems--menu={option.items}
    on:keyup={keyHandlerUp}
    on:keydown={keyHandlerDown}
    role="menuitem"
>
    {#if option.link}
        <AnchorItem
            {option}
            on:click
            on:dropdownClose
            on:mouseenter={mouseenterHandler}
            on:mouseleave={mouseleaveHandler}
        />
    {:else}
        {#if option.items}
            <ButtonItem
                {option}
                cssClass="prom-dropdown__listitems-menu"
                hasPopup={true}
                on:click={clickHandler}
                on:mouseenter={mouseenterHandler}
                on:mouseleave={mouseleaveHandler}
            />

            <section
                hidden
                class="prom-dropdown prom-dropdown__submenu"
            >
                <section class="prom-dropdown__body">
                    {#each option.items as list, index}
                    <List
                        {index}
                        {list}
                        isSubmenu="true"
                        on:click
                        on:dropdownClose
                        on:keyup
                    />
                    {/each}
                </section>
            </section>
        {:else}
            <ButtonItem
                {option}
                hasPopup={false}
                on:click
                on:mouseenter={mouseenterHandler}
                on:mouseleave={mouseleaveHandler}
            />
        {/if}
    {/if}
</li>

<script>
    import AnchorItem from './AnchorItem.svelte';
    import ButtonItem from './ButtonItem.svelte';
    import List from './List.svelte';
    import { Keys } from '@itslearning/atlas/keyboard/keys';
    import { isMobile } from '@itslearning/atlas/detectors/UserAgentHelper';
    import { normalizeKey } from '@itslearning/atlas/keyboard/normalize';
    import { focusPreviousListItem, focusNextListItem, goToNextList,
             goToPreviousList } from './navigationHelper.js';
    import { focusFirstItemIn, hide, hidden, hideOpenSubmenus, returnFocusToParentDropdown,
        show, isMenuItem, removeFocusFromParentDropdown } from './dropdownHelper.js';

    export let isSubmenu = false;

    export let option = null;

    function clickHandler({ detail: { event } }) {
        const button = event.currentTarget;
        const submenu = event.currentTarget.nextElementSibling;

        toggleMenu(button, submenu, false);
    }

    function mouseenterHandler({ detail: { event } }) {
        // TODO: should be removed in https://jira.itslearning.com/browse/TRK-6805
        if (isMobile()) {
            return;
        }

        const item = event.currentTarget;
        const submenu = event.currentTarget.nextElementSibling;

        if (isMenuItem(item)) {
            openMenu(item, submenu, true);
        } else if (!isSubmenu) {
            hideOpenSubmenus();
        }
    }

    function mouseleaveHandler({ detail: { event } }) {
        // TODO: should be removed in https://jira.itslearning.com/browse/TRK-6805
        if (isMobile()) {
            return;
        }

        const submenu = event.currentTarget.nextElementSibling;

        if (!isSubmenu && submenu && !submenu.contains(event.relatedTarget)) {
            closeMenu(submenu, false);
        }
    }

    function moveToNextItem(currentItem){
        const nextItemFocused = focusNextListItem(currentItem);

        if (!nextItemFocused) { goToNextList(currentItem); }
    }

    function moveToPreviousItem(currentItem){
        const previousItemFocused = focusPreviousListItem(currentItem);

        if (!previousItemFocused) { goToPreviousList(currentItem); }
    }

    function keyHandlerDown(event) {
        const { key } = event;
        const button = event.target;

        switch (normalizeKey(key)) {
            case Keys.UP:
                event.preventDefault();
                moveToPreviousItem(button);
                break;
            case Keys.DOWN:
                event.preventDefault();
                moveToNextItem(button);
                break;
        default:
            return;
        }
    }

    function keyHandlerUp(event) {
        const { key } = event;
        const button = event.target;
        const submenu = event.target.nextElementSibling;

        switch (normalizeKey(key)) {
            case Keys.LEFT:
                hideOpenSubmenus();
                returnFocusToParentDropdown();
                break;
            case Keys.RIGHT:
                if (isMenuItem(button)) {
                    toggleMenu(button, submenu, false);
                }
                break;
        default:
            return;
        }
    }

    function openMenu(button, submenu, isHover) {
        hideOpenSubmenus();
        removeFocusFromParentDropdown();
        show(submenu);

        button.classList.add('open');
        button.setAttribute('aria-expanded', true);

        if (!isHover) {
            focusFirstItemIn(submenu);
        }
    }

    function closeMenu(submenu, isHover) {
        if (!hidden(submenu)) {
            hide(submenu);
            const button = document.querySelector('.prom-dropdown__listitems-menu.open');
            button.setAttribute('aria-expanded', false);
            button.classList.remove('open');

            if (!isHover) {
                returnFocusToParentDropdown();
            }
        }
    }

    function toggleMenu(button, submenu, isHover) {
        hidden(submenu) ?
            openMenu(button, submenu, isHover) :
            closeMenu(submenu, true);
    }
</script>
